import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CustomHttp, ConfigServerService } from '../../../core';
import { Pessoa } from '../pessoa';

@Injectable({
    providedIn: 'root'
})
export class PessoaCrudHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/pessoa`;
    }

    /** Carrega uma única pessoa através do seu ID */
    find(id: number): Observable<Pessoa> {
        return this.customHttp.get<Pessoa>(`${this.pathApi}/${id}`);
    }

    /** Carrega uma única pessoa através do seu ID */
    load(id: number): Observable<Pessoa> {
        return this.customHttp.get<Pessoa>(`${this.pathApi}/${id}/load`);
    }
}
